import { RequestDTO } from './request-dto';

export interface PageRequestDTO extends RequestDTO {
    pageSize?: number;
    pageNumber?: number;
    order?: string;
    sortBy?: string;
}
